export const FRESHDESK_WIDGET_ENGLISH_ID = 80000007951
export const FRESHDESK_WIDGET_WELSH_ID = 80000008802

// export const SUPPORTED_LANGUAGES = [
//   { name: LanguageNames.English, localeCode: LanguageCodes['en-GB'] },
//   { name: LanguageNames.Cymraeg, localeCode: LanguageCodes['cy-GB'] },
// ]
